import React from "react"

import {BaseInput as Input}
  from "core/js/components/presentation/molecules/input/base";

export const EmailInput = (props) => {
  return (
    <Input {...props} type="email" />
  )
}
